import { ICounterparty, IOperationResult, IPaged, IQueryParams } from '@ipnote/interface';
import { createActionGroup, props } from '@ngrx/store';

export const counterpartiesActions = createActionGroup({
  source: 'Counterparties',
  events: {
    'load counterparties': props<{ pagedQueryParams: IQueryParams }>(),
    'load counterparties success': props<{ counterparties: IPaged<ICounterparty> }>(),
    'load counterparties failure': props<{ error: string }>(),

    'delete counterparties': props<{ counterpartyIds: number[] }>(),
    'delete counterparties success': props<{ counterpartyIds: number[], result: IOperationResult }>(),
    'delete counterparties failure': props<{ error: string}>(),

    'update counterparty': props<{ counterpartyId: number | string; data: Partial<ICounterparty> }>(),
    'update counterparty success': props<{ counterparty: ICounterparty }>(),
    'update counterparty failure': props<{ error: string }>(),
  },
});